import ReportTransferAnalysis from '../components/ui/report-transfer-analysis.js';
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";



export default function TransferReportPage(props) {
    return (
        <CaseDatabaseCheck>
        <CurrentCaseRequired>
        <ReportTransferAnalysis />
        </CurrentCaseRequired>
        </CaseDatabaseCheck>
    );
}